import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import Layout from '../components/layout/Layout';
import { legacyRedirects } from '../config/navigation';

const HomePage = lazy(() => import('../pages/Home'));
const AboutPage = lazy(() => import('../pages/About'));
const ProductsPage = lazy(() => import('../pages/Products'));
const ManufacturingPage = lazy(() => import('../pages/Manufacturing'));
const ResponsibleManufacturingPage = lazy(() => import('../pages/ResponsibleManufacturing'));
const GlobalSourcingPage = lazy(() => import('../pages/GlobalSourcing'));
const TeamPage = lazy(() => import('../pages/Team'));
const CustomersPage = lazy(() => import('../pages/Customers'));
const ContactPage = lazy(() => import('../pages/Contact'));
const CareersPage = lazy(() => import('../pages/Careers'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

function RouteFallback() {
  return (
    <Box sx={{ minHeight: '40vh', display: 'grid', placeItems: 'center' }} role="status" aria-live="polite">
      <CircularProgress aria-label="Loading page" />
    </Box>
  );
}

export default function AppRoutes() {
  return (
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="products" element={<ProductsPage />} />
          <Route path="manufacturing" element={<ManufacturingPage />} />
          <Route path="responsibility" element={<ResponsibleManufacturingPage />} />
          <Route path="global-sourcing" element={<GlobalSourcingPage />} />
          <Route path="team" element={<TeamPage />} />
          <Route path="customers" element={<CustomersPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="careers" element={<CareersPage />} />
          {legacyRedirects.map((item) => (
            <Route
              key={item.from}
              path={item.from.replace(/^\//, '')}
              element={<Navigate to={item.to} replace />}
            />
          ))}
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}
